module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "custom-reviews-content"
  }, [_c('div', {
    staticClass: "custom-reviews-content__container"
  }, [(_vm.yelper == "unknown") ? _c('div', {
    staticClass: "custom-reviews-content__yelper-buttons"
  }, [_c('img', {
    attrs: {
      "src": "https://pediatricdentistorangeca.com/wp-content/uploads/yelp-logo.png",
      "alt": "yelp-logo"
    }
  }), _c('h1', [_vm._v("Are you a Yelper?")]), _c('a', {
    staticClass: "custom-reviews-content__yelper-button",
    style: ({
      'background': '#0183D6'
    }),
    on: {
      "click": function($event) {
        _vm.isYelper("yes")
      }
    }
  }, [_vm._v("YES")]), _c('a', {
    staticClass: "custom-reviews-content__yelper-button",
    style: ({
      'background': '#D98430'
    }),
    on: {
      "click": function($event) {
        _vm.isYelper("no")
      }
    }
  }, [_vm._v("NO")])]) : _vm._e(), (_vm.yelper == "yes") ? _c('a', {
    staticClass: "custom-reviews-content__button",
    style: ({
      'background': '#a0251e'
    }),
    attrs: {
      "href": "https://www.yelp.com/biz/h2-pediatric-dentistry-orange-4",
      "target": "_blank"
    }
  }, [_c('img', {
    staticClass: "custom-reviews-content__social-icon",
    attrs: {
      "src": "https://pediatricdentistorangeca.com/wp-content/uploads/yelp-square.png"
    }
  }), _c('div', {
    staticClass: "custom-reviews-content__text"
  }, [_vm._v("Review us on Yelp")])]) : _vm._e(), (_vm.yelper == "no") ? _c('a', {
    staticClass: "custom-reviews-content__button",
    style: ({
      'background': '#2d417a'
    }),
    attrs: {
      "href": "https://www.facebook.com/H2-Pediatric-Dentistry-243117415824210/",
      "target": "_blank"
    }
  }, [_c('img', {
    staticClass: "custom-reviews-content__social-icon",
    attrs: {
      "src": "https://pediatricdentistorangeca.com/wp-content/uploads/fb_icon.png"
    }
  }), _c('div', {
    staticClass: "custom-reviews-content__text"
  }, [_vm._v("Review us on Facebook")])]) : _vm._e(), (_vm.yelper == "no") ? _c('a', {
    staticClass: "custom-reviews-content__button",
    style: ({
      'background': '#e5a30e'
    }),
    attrs: {
      "href": "https://www.google.com/search?q=h2+pediatric+dentistry&oq=h2+pediatri&aqs=chrome.0.0j69i60j69i57j69i61j0l2.1831j0j7&sourceid=chrome&ie=UTF-8#lrd=0x80dcd9c358ab3697:0x9017aca854acedb2,3,,,",
      "target": "_blank"
    }
  }, [_c('img', {
    staticClass: "custom-reviews-content__social-icon",
    attrs: {
      "src": "https://pediatricdentistorangeca.com/wp-content/uploads/new-google-favicon-512.png"
    }
  }), _c('div', {
    staticClass: "custom-reviews-content__text"
  }, [_vm._v("Review us on Google")])]) : _vm._e()])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5e57ddee","hasScoped":false}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./src/components/custom/custom-reviews-content/custom-reviews-content.pug
// module id = 579
// module chunks = 1